import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router";
import { placeOf } from "../../../shared/inApp";
import { IN_APP, onFromApp, postToApp, tellAppReady } from "../../lib/inApp";
import { TAB_PLACES } from "./tabs";

/**
 * Inside the Flashsuite phone app (flashsuite-phone docs/APP-MODE.md section 3): tell the app where the page is
 * on every route change, the first one too, and go to a tab's own screen when the app asks, which it does when
 * this screen's tab is pressed while the page wandered into another tab's area. The shell is the first real
 * screen, so it tells the app it is drawn.
 */
export function useAppBridge(): void {
  const { pathname, search } = useLocation();
  const navigate = useNavigate();

  useEffect(tellAppReady, []);

  useEffect(() => {
    if (IN_APP) postToApp(placeOf(TAB_PLACES, pathname, search));
  }, [pathname, search]);

  useEffect(() => {
    if (!IN_APP) return;
    return onFromApp((m) => {
      if (m.kind !== "tab-again") return;
      const tab = TAB_PLACES.find((t) => t.id === m.tab);
      if (tab) navigate(tab.to);
    });
  }, [navigate]);
}
